export enum PlanListActionsEnum {
  PLAN_LIST_INIT_PAGE = 'PLAN_LIST_INIT_PAGE',
  PLAN_LIST_CREATE_PLAN = 'PLAN_LIST_CREATE_PLAN',
  PLAN_LIST_UPDATE_PLAN = 'PLAN_LIST_UPDATE_PLAN',
  PLAN_LIST_UPDATE_PLAN_STATUS = 'PLAN_LIST_UPDATE_PLAN_STATUS',
  PLAN_LIST_UPDATE_ERKNM_PLAN_STATUS = 'PLAN_LIST_UPDATE_ERKNM_PLAN_STATUS',
  PLAN_LIST_UPDATE_PLAN_STATUS_TO_CONSIDER = 'PLAN_LIST_UPDATE_PLAN_STATUS_TO_CONSIDER',
  PLAN_LIST_REMOVE_PLANS = 'PLAN_LIST_REMOVE_PLANS',
  PLAN_LIST_GET_DATA = 'PLAN_LIST_GET_DATA',
  PLAN_LIST_GET_DATA_NEXT_PAGE = 'PLAN_LIST_GET_DATA_NEXT_PAGE',
  PLAN_LIST_SET_DATA = 'PLAN_LIST_SET_DATA',
  PLAN_LIST_SET_ORDER = 'PLAN_LIST_SET_ORDER',
  PLAN_LIST_EXPORT_PLANS = 'PLAN_LIST_EXPORT_PLANS',
  PLAN_LIST_EXPORT_PLAN_BY_ID = 'PLAN_LIST_EXPORT_PLAN_BY_ID',
  PLAN_LIST_EXPORT_DOCS_FOR_KNO = 'PLAN_LIST_EXPORT_DOCS_FOR_KNO',
  PLAN_LIST_LINK_KNM_TO_PLAN = 'PLAN_LIST_LINK_KNM_TO_PLAN',
  PLAN_LIST_SET_STATUSES = 'PLAN_LIST_SET_STATUSES',
  PLAN_LIST_GET_STATUSES = 'PLAN_LIST_GET_STATUSES',
  PLAN_LIST_GET_PLAN_BY_ID = 'PLAN_LIST_GET_PLAN_BY_ID',
  PLAN_LIST_SET_PLAN = 'PLAN_LIST_SET_PLAN',
  PLAN_LIST_SIGN_PLAN_BY_ID = 'PLAN_LIST_SIGN_PLAN_BY_ID',
  PLAN_LIST_GET_APPROVED_FOR_CURRENT_YEAR = 'PLAN_LIST_GET_APPROVED_FOR_CURRENT_YEAR',
  PLAN_LIST_SET_APPROVED_FOR_CURRENT_YEAR = 'PLAN_LIST_SET_APPROVED_FOR_CURRENT_YEAR',
  PLAN_LIST_GET_PLAN_SELECT_OPTIONS = 'PLAN_LIST_GET_PLAN_SELECT_OPTIONS',
}
